import { render, staticRenderFns } from "./clue.vue?vue&type=template&id=fb0c2914&scoped=true&"
import script from "./clue.vue?vue&type=script&lang=ts&"
export * from "./clue.vue?vue&type=script&lang=ts&"
import style0 from "./clue.vue?vue&type=style&index=0&id=fb0c2914&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0c2914",
  null
  
)

export default component.exports